import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { DemoConversionRewardMonth } from '../../model/helpers/interfaces'

import { runApiGet } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

interface DemoConversionRewardMonthsApiOptions {
  onLoadingChange: (loading: boolean) => void
}

const toMonthOption = (month: DemoConversionRewardMonth): AppSelectOption<string> => ({
  value: month.value,
  text: month.label,
})

export const useDemoConversionRewardMonthsApi = async (
  options: DemoConversionRewardMonthsApiOptions,
): Promise<AppSelectOption<string>[] | null> => {
  const url = useAdminRoutes('admin.helpers.tutor.demo-conversion-rewards.months')

  return runApiGet<AppSelectOption<string>[]>(url, {
    setLoading: options.onLoadingChange,
    handle: (response) => {
      const months: DemoConversionRewardMonth[] = response.data ?? []

      return months.map(toMonthOption)
    },
  })
}
